export const Introduce = () => import('@/views/Introduce/index.vue');
export const Situation = () => import('@/views/Situation/index.vue');
export const Industry = () => import('@/views/Industry/index.vue');
export const Operation = () => import('@/views/Operation/index.vue');
export const Safe = () => import('@/views/Safe/index.vue');
export const OM = () => import('@/views/OM/index.vue');

export const Inspection = () => import('@/views/Operation/inspection.vue');
